import React from 'react';
import { HourglassIcon } from 'lucide-react';
const consequences = ['Die Bonos sind nicht mehr kostenlos.', 'Der Preis erhöht sich auf €47 (für neue Käufer).', 'Die Community könnte voll sein.'];
export function Scarcity() {
  return <section className="border-b border-line bg-canvas py-20 lg:py-28" style={{
    paddingTop: "12px",
    paddingBottom: "12px"
  }} data-id="element-70" data-mp="20kvv290mxjb4">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)] lg:gap-16" data-id="element-71" data-mp="1whzgcte7u7cg">
        

        <div className="self-start rounded-2xl bg-mint-soft p-8 shadow-lg shadow-forest/15" style={{
        paddingTop: "0px",
        paddingBottom: "0px"
      }} data-id="element-72" data-mp="13vy1uv8j9tg2">
          <p className="flex items-center gap-2 font-mono text-xs font-medium text-emerald" style={{
          gap: "9px"
        }} data-id="element-73" data-mp="1hoo0q095usul">
            <HourglassIcon className="h-4 w-4" aria-hidden="true" data-id="element-74" data-mp="p68taey42n5r" />
            Verfügbare Plätze diese Woche
          </p>

          <p className="mt-6 font-mono text-6xl font-semibold leading-none text-forest" style={{
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-75" data-mp="l5gmrtgmiwd6">24</p>
          <p className="mt-2 text-sm text-prose" style={{
          marginTop: "4px",
          marginBottom: "4px"
        }} data-id="element-76" data-mp="31fpphunirzz0">von 47 Plätzen noch frei</p>

          <div className="mt-8 h-2 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={23} aria-valuemin={0} aria-valuemax={47} aria-label="Bereits vergebene Plätze" style={{
          marginTop: "10px",
          marginBottom: "10px"
        }} data-id="element-77" data-mp="3b72b44iq5twl">
            <div className="h-full w-1/2 rounded-full bg-emerald" data-id="element-78" data-mp="2il138p7jse96" />
          </div>

          <dl className="mt-6 grid grid-cols-2 gap-4 font-mono text-sm" style={{
          marginTop: "0px",
          marginBottom: "0px",
          gap: "6px"
        }} data-id="element-79" data-mp="2ni9lepsp4iaf">
            <div data-id="element-80" data-mp="2xgqfhvmxld0p">
              <dt className="text-prose" data-id="element-81" data-mp="2xh8j5dbxatin">Bereits gekauft</dt>
              <dd className="mt-1 text-forest" data-id="element-82" data-mp="7qvfmlagr2yw">23</dd>
            </div>
            <div data-id="element-83" data-mp="7qlrz4cw57wd">
              <dt className="text-prose" data-id="element-84" data-mp="7t7u2oh0iv77">Noch verfügbar</dt>
              <dd className="mt-1 font-semibold text-emerald" data-id="element-85" data-mp="con5zavgmh0z">24</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>;
}